import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { CreditAgreementActions } from './credit-agreement.actions';

@Injectable({
  providedIn: 'root'
})
export class CreditAgreementEffects {
  sendCreditAgreementEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendCreditAgreementEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(CreditAgreementActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
